import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FileSaver from 'file-saver';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import { IFileParams } from 'entities/File/File.models';
import { fileTransport } from 'entities/File/File.transport';

interface IState {
  isFileLoading: boolean;
}

const initialState: IState = {
  isFileLoading: false,
};

export const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setIsFileLoading(state, action: PayloadAction<boolean>) {
      state.isFileLoading = action.payload;
    },
  },
});

export const { setIsFileLoading } = fileSlice.actions;

export const selectIsFileLoading = (state: RootState) => state.file.isFileLoading;

export const fileReducer = fileSlice.reducer;

export const downloadFile =
  ({ name, ...rest }: IFileParams) =>
  async () => {
    try {
      const response = await fileTransport.downloadFile(rest);
      FileSaver.saveAs(response, name);
    } catch (error) {
      axiosErrorHandler(error);
    }
  };

export const uploadFile = (file: File) => async (dispatch: AppDispatch) => {
  dispatch(setIsFileLoading(true));

  const formData = new FormData();
  formData.append('file', file);

  try {
    return await fileTransport.uploadFile(formData);
  } catch (error) {
    axiosErrorHandler(error);
    return null;
  } finally {
    dispatch(setIsFileLoading(false));
  }
};
